import * as React from 'react';
import { StyledSocialButton } from './Styles';
import { openSocialNetworkPopup, getSocialNetworkUrl } from '../../api/socialNetwork';
import { getSocialNetworkIcon } from './SocialMediaSvgs';
import ToolTip from '../Tooltip/Tooltip';
export var SocialMediaButton = function SocialMediaButton(props) {
  if (!props.network) {
    return null;
  }

  var shareUrl = getSocialNetworkUrl(props.network, props.title, props.tags);
  var svgIcon = getSocialNetworkIcon(props.network);

  var onClick = function onClick(e) {
    e.preventDefault();
    openSocialNetworkPopup(shareUrl);
    props.logSocialShare(props.network);
  };

  var dataLookup = props.network.toLowerCase() + '-network';
  return React.createElement(StyledSocialButton, {
    className: 'social-btn',
    onClick: onClick,
    "data-lookup": dataLookup
  }, svgIcon != null ? React.createElement(svgIcon) : null, !props.tooltipText ? null : React.createElement("div", {
    className: 'tooltip-container'
  }, React.createElement(ToolTip, {
    type: 'bottom',
    visible: true,
    tooltipText: props.tooltipText
  })));
};
export default SocialMediaButton;